import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-custom-datepicker',
  template: `
    <div style="margin-bottom: 15px;">
      <label>{{ props.label }}</label>
    </div>
    <p-calendar
      [showIcon]="true"
      [icon]="showTime ? timeIcon : calendarIcon"
      [showButtonBar]="true"
      [timeOnly]="showTime"
      [hourFormat]="'12'"
      [minDate]="minDate"
      [placeholder]="placeholder"
      [formControl]="$any(formControl)"
      [required]="isRequired"
    ></p-calendar>

    <p-toast></p-toast>
  `
})
export class CustomDatepickerComponent extends FieldType implements OnInit {
  showTime!: boolean;
  timeIcon = 'pi pi-clock';
  calendarIcon = 'pi pi-calendar';
  placeholder!: string;
  minDate!: Date | null;
  isRequired!: boolean;

  @Output() dateValidator = new EventEmitter<boolean>();

  ngOnInit() {
    // this.minDate = new Date();
    this.showTime = this.props['showTime'];
    this.placeholder = this.showTime ? '09:00 AM' : '05/23/2024';
    this.isRequired = this.props.required as boolean;
    this.minDate = this.props['minDate'] as Date;
  }
}
